import { Carousel, Col, Container, Row } from "react-bootstrap";
import clsx from "classnames";
import { chunk } from "lodash";
import PropTypes from "prop-types";
import ChevronLeft from "@/assets/ChevronLeft.svg";
import ChevronRight from "@/assets/ChevronRight.svg";
import classes from "./styles.module.scss";
import { LogoCard, Title } from "@/ui";
import { useEffect, useState } from "react";
import { useMediaQuery } from "@react-hook/media-query";

export function LogoCarousel({
  className,
  bgColor,
  textColor,
  titleColor,
  title,
  items,
  visibleCount: desktopVisibleCount,
}) {
  const [visibleCount, setVisibleCount] = useState(1);
  const xl = useMediaQuery("only screen and (min-width: 1200px)");
  const lg = useMediaQuery("only screen and (min-width: 992px)");
  const md = useMediaQuery("only screen and (min-width: 768px)");

  useEffect(() => {
    setVisibleCount(xl ? desktopVisibleCount : lg ? 3 : md ? 2 : 1);
  }, [xl, lg, md, desktopVisibleCount]);

  if (!items || items.length === 0) return null;

  const hasImages = items.some((item) => item.img?.url);
  if (!hasImages) return null;

  return (
    <div className={clsx(className, bgColor, textColor, classes.logos)}>
      <Container className="mw-xxl">
        {title && <Title className={titleColor} title={title} />}
        <Carousel
          className={classes.logos__carousel}
          controls
          prevIcon={<ChevronLeft width="14" height="25" />}
          nextIcon={<ChevronRight width="14" height="25" />}
        >
          {chunk(items, visibleCount).map((group, idx) => (
            <Carousel.Item key={idx}>
              <Row className="justify-content-center">
                {group.map(({ img, title, url_slug }, k) => (
                  <Col key={k} className="py-3" xs={6} sm={4} md={3} lg={2}>
                    <LogoCard img={img?.url} name={title} href={url_slug} />
                  </Col>
                ))}
              </Row>
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
    </div>
  );
}

export default LogoCarousel;
